import { z } from 'zod'

/** Which billing control a `billing.settings_changed` activity row is about. */
export const BILLING_SETTINGS = ['auto_reload', 'card', 'low_balance_threshold'] as const

export const billingSettingSchema = z.enum(BILLING_SETTINGS)

export type BillingSetting = z.infer<typeof billingSettingSchema>
